module.exports = __webpack_public_path__ + "static/media/windows-logo.e11241ff.svg";